import { getShipments } from 'utils/actions/shipments'
import { tabClicked } from 'utils/actions/ui'
import { getUserDetails } from 'utils/hooks/useUserDetails'
import { deselectOtherCheckboxFilters, SHIPMENT_TABS } from 'apps/booking/constants/shipments'
import { FILTERS_SUBMIT_SUCCESS, FILTERS_SUBMIT_FAILURE } from 'apps/booking/utils/actions/filters'
import { getShipmentCounts } from 'apps/booking/utils/actions/shipmentsStats'
import { handleSidebar } from 'apps/booking/utils/actions/sidebar'
import { debounce } from 'utils/debounce'
import { clearCheckboxFilters } from '../actions/filters'
import { selectStat } from '../actions/shipmentsStats'
import { updateCheckboxFromFilter } from '../updateCheckboxFromQuickFilter'

// Temporary until product finalizes flow
const defaultCheckboxCountParams = {
  ...deselectOtherCheckboxFilters,
  hasOptions: undefined,
}

const handleFiltersSubmit = filtersParams => {
  const {
    action,
    currentUserId,
    getShipmentsParams,
    myLoads,
    podIds,
    searchParams,
    selectedTabIndex,
    stateOptions,
    store,
  } = filtersParams
  const currentUserParam = { usersId: currentUserId, usersType: 'user' }
  const clearUserParam = { usersId: '', usersType: '' }

  if (myLoads) {
    const countParams = { podIds: [], ...currentUserParam, ...searchParams }
    if (action.statQuickFilter) {
      updateCheckboxFromFilter(action, clearCheckboxFilters, store)
      store.dispatch(getShipmentCounts({ ...countParams, ...defaultCheckboxCountParams }))
    } else store.dispatch(getShipmentCounts({ ...countParams }))
  } else {
    const countParams = { podIds, ...clearUserParam, ...searchParams }
    if (action.statQuickFilter) {
      updateCheckboxFromFilter(action, clearCheckboxFilters, store)
      store.dispatch(getShipmentCounts({ ...countParams, ...defaultCheckboxCountParams }))
    } else store.dispatch(getShipmentCounts({ ...countParams }))
  }
  store.dispatch(getShipments(getShipmentsParams, SHIPMENT_TABS))
  store.dispatch(handleSidebar())
  store.dispatch(selectStat())

  // Auto-selects tab if currentTab !== selected status filter
  const findStateOptionsIndex = SHIPMENT_TABS.findIndex(s => s.status.includes(stateOptions))
  if (stateOptions && !SHIPMENT_TABS[selectedTabIndex].status.includes(stateOptions))
    store.dispatch(tabClicked(findStateOptionsIndex, SHIPMENT_TABS))
}

// Used for open text inputs (ID, PO, BOL, etc and Radius)
const debounceHandleFiltersSubmit = debounce(handleFiltersSubmit, 250)

export const filtersSubmit = store => next => action => {
  // Allows the action to reach reducer first for updated searchParams state
  if (!action.submitFilters) return next(action)
  next(action)
  const { payload = {} } = action
  const actionWith = data => {
    const finalAction = { ...action, ...data }
    delete finalAction[payload]
    return finalAction
  }
  try {
    const { id: currentUserId } = getUserDetails() || {}
    const currentState = store.getState()
    const {
      shipments: { params },
      filters: {
        data: { submittedShipmentParams } = {},
        stateOptions,
        myLoads,
        searchParams,
        searchParams: { podIds },
      },
      ui: { selectedTabIndex },
    } = currentState
    const getShipmentsParams = {
      ...params,
      filters: { ...params.filters, ...searchParams },
      pageCount: 0,
    }
    const filtersParams = {
      currentUserId,
      stateOptions,
      searchParams,
      podIds,
      myLoads,
      store,
      getShipmentsParams,
      selectedTabIndex,
      action,
    }

    // Submit request only if newShipmentParams !== prevShipmentParams
    if (
      JSON.stringify(getShipmentsParams) === JSON.stringify(submittedShipmentParams) &&
      !action.refresh
    )
      return next(action)
    if (action.debounce) debounceHandleFiltersSubmit(filtersParams)
    else handleFiltersSubmit(filtersParams)
    return next(
      actionWith({
        type: FILTERS_SUBMIT_SUCCESS,
        payload: {
          ...payload,
          data: { submittedShipmentParams: getShipmentsParams },
        },
      })
    )
  } catch (error) {
    return next(
      actionWith({
        type: FILTERS_SUBMIT_FAILURE,
        payload: {
          ...payload,
          error,
        },
      })
    )
  }
}
